import { render, staticRenderFns } from "./YogaPlace.vue?vue&type=template&id=3887bc90&scoped=true&"
import script from "./YogaPlace.vue?vue&type=script&lang=js&"
export * from "./YogaPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3887bc90",
  null
  
)

export default component.exports